module.exports = __webpack_public_path__ + "img/lg_ring_g_l_null_null@2x.323afad5.png";